const cardUpdateCoupons = {
  updcard50: 'UPDCARD50',
  updcardfreeproduct: 'UPDCARDFREEPRODUCT',
  updcardfreecase: 'UPDCARDFREECASE',
} as const

export type CardUpdateCoupon = typeof cardUpdateCoupons[keyof typeof cardUpdateCoupons]


export default cardUpdateCoupons
